import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ProjectDocuments" }
const _hoisted_2 = { class: "ProjectDocuments__list" }
const _hoisted_3 = { class: "ProjectDocuments__tools" }

import { computed, PropType } from "vue";
import { DocType, Project, Document, Line } from "@/types";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import InnSection from "@/components/general/Section.vue";
import { useDocumentsStore } from "@/stores/documents";
import DocumentCard from "@/components/pages/documents/card/DocumentCard.vue";
import { useRouter } from "vue-router";
import { documentToPrefix, documentToSlug } from "@/tools/document";
import api from "@/api";
import { useClientStore } from "@/stores/clients";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectDocuments',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
    doctype: {
        type: String as PropType<DocType>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const documentsStore = useDocumentsStore();
const clientsStore = useClientStore();
const companyStore = useCompanyStore();
const uiStore = useUiStore();

const canICreate = computed(() => {
    return props.project.user_id === uiStore.user?.id;
});

const trDocType = computed(() => {
    return props.doctype === "invoice" ? "Factuur" : "Offerte";
});

const addDocument = () => {
    const client = clientsStore.getItemById(props.project.clientId);
    const document = documentsStore.getNew();
    document.projectId = props.project.id;
    document.doctype = props.doctype;
    document.user_id = props.project.user_id;
    document.title = props.project.projectName;
    document.rate = props.project.rate;
    if (client) {
        document.clientName = client.contactPerson;
    }
    create(document);
};

const documents = computed(() => {
    return documentsStore.list.filter(
        (doc) =>
            doc.projectId === props.project.id && doc.doctype === props.doctype
    );
});

const select = (document: Document) => {
    const slug = documentToSlug(document);
    const prefix = document.doctype;
    router.push({
        name: "Document",
        params: { slug, prefix },
    });
};

const cloneLine = (original: Line, document: Document) => {
    const clone: Line = { ...original };
    clone.documentId = document.id;
    api.create(clone, "documentLines").then((response) => {
        clone.id = response.id;
        document.lines.push(clone);
        uiStore.message("Post aangemaakt..");
    });
};

const cloneDocument = async () => {
    const original = documents.value[documents.value.length - 1];
    const clone = documentsStore.getNew();
    clone.projectId = original.projectId;
    clone.doctype = original.doctype;
    clone.user_id = original.user_id;
    clone.title = original.title;
    clone.rate = original.rate;
    clone.clientName = original.clientName;
    // wait for create to know the id
    await create(clone);
    for (const line of original.lines) {
        cloneLine(line, clone);
    }
};

const create = async (document: Document) => {
    return new Promise((resolve, reject) => {
        api.create(document, "documents").then((response) => {
            document.id = response.id;
            document.nr = response.nr;
            documentsStore.create(document);
            const prefix = documentToPrefix(document);
            uiStore.message(prefix + " aangemaakt..");
            resolve(document);
        });
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (documents.value.length > 0)
      ? (_openBlock(), _createBlock(InnSection, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value, (document) => {
                return (_openBlock(), _createBlock(DocumentCard, {
                  onClick: ($event: any) => (select(document)),
                  key: document.id,
                  document: document
                }, null, 8, ["onClick", "document"]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (canICreate.value)
      ? (_openBlock(), _createBlock(InnSection, { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(IconButton, {
                "icon-id": "plus",
                onClick: addDocument
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(trDocType.value) + " toevoegen ", 1)
                ]),
                _: 1
              }),
              (__props.doctype === 'invoice' && documents.value.length > 0)
                ? (_openBlock(), _createBlock(IconButton, {
                    key: 0,
                    "icon-id": "clone",
                    type: "r",
                    onClick: cloneDocument
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode(" Laatste factuur clonen ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})